export default function getRequiredLabel(label) {
  return `${label} *`;
}
